import { forwardRef, useRef } from "react";
import {
  Bold,
  Heading1,
  Heading2,
  Italic,
  Link as LinkIcon,
  List,
  ListOrdered,
  Quote,
  Redo2,
  Underline,
  Undo2,
} from "lucide-react";

const DocxEditor = forwardRef(function DocxEditor({ html, onChange }, ref) {
  const divRef = useRef(null);

  function exec(command, value = null) {
    divRef.current?.focus();
    document.execCommand(command, false, value);
    onChange?.(divRef.current?.innerHTML || "");
  }

  function insertLink() {
    const url = window.prompt("输入链接地址，例如 https://example.com");
    if (url) exec("createLink", url);
  }

  return (
    <div className="docx-editor">
      <div className="editor-toolbar" aria-label="文字编辑工具栏">
        <button type="button" className="tool-btn" title="加粗" onClick={() => exec("bold")}>
          <Bold size={16} />
        </button>
        <button type="button" className="tool-btn" title="斜体" onClick={() => exec("italic")}>
          <Italic size={16} />
        </button>
        <button type="button" className="tool-btn" title="下划线" onClick={() => exec("underline")}>
          <Underline size={16} />
        </button>
        <span className="toolbar-sep" />
        <button type="button" className="tool-btn" title="一级标题" onClick={() => exec("formatBlock", "<h1>")}>
          <Heading1 size={16} />
        </button>
        <button type="button" className="tool-btn" title="二级标题" onClick={() => exec("formatBlock", "<h2>")}>
          <Heading2 size={16} />
        </button>
        <span className="toolbar-sep" />
        <button type="button" className="tool-btn" title="无序列表" onClick={() => exec("insertUnorderedList")}>
          <List size={16} />
        </button>
        <button type="button" className="tool-btn" title="有序列表" onClick={() => exec("insertOrderedList")}>
          <ListOrdered size={16} />
        </button>
        <button type="button" className="tool-btn" title="引用" onClick={() => exec("formatBlock", "<blockquote>")}>
          <Quote size={16} />
        </button>
        <button type="button" className="tool-btn" title="插入链接" onClick={insertLink}>
          <LinkIcon size={16} />
        </button>
        <span className="toolbar-sep" />
        <button type="button" className="tool-btn" title="撤销" onClick={() => exec("undo")}>
          <Undo2 size={16} />
        </button>
        <button type="button" className="tool-btn" title="重做" onClick={() => exec("redo")}>
          <Redo2 size={16} />
        </button>
      </div>
      <div
        ref={(el) => {
          divRef.current = el;
          if (ref) {
            if (typeof ref === "function") ref(el);
            else ref.current = el;
          }
        }}
        className="docx-content"
        contentEditable
        suppressContentEditableWarning
        dangerouslySetInnerHTML={{ __html: html }}
        onInput={(e) => onChange?.(e.currentTarget.innerHTML)}
        onBlur={(e) => onChange?.(e.currentTarget.innerHTML)}
      />
    </div>
  );
});

export default DocxEditor;
